<template>
    <div class="layout-search">
        <transition name="search-container" @enter="onEnter">
            <div v-show="searchActive" class="search-container" @click="onSearchContainerClick">
                <i class="pi pi-search"></i>
                <InputText maxlength="98" v-model="keyword" ref="searchInput" type="text" enterkeyhint="search" name="search" placeholder="Ricerca" @keydown="onInputKeydown" />
            </div>
        </transition>
    </div>
</template>

<script>
//const debug = require('debug')('xlite-web-client:AppSearch')

export default {
    name: "AppSearch",
    emits: ["search-click", "search-hide"],
    props: {
        searchActive: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            keyword: null
        }
    },
    methods: {
        onEnter() {
            if (this.$refs.searchInput) {
                this.$refs.searchInput.$el.focus();
            }
        },
        onSearchContainerClick(event) {
            this.$emit("search-click", event);
        },
        //goSearch(keyword){
        goSearch(){
            //this.$router.replace({ name: 'Search', params: { keyword: keyword }})
            this.$router.replace({ name: 'Search' })
        },
        onInputKeydown(event) {
            const key = event.which;
            
            //escape (27), tab (9) and enter (13)
            if (key === 27 || key === 9 || key === 13) {
                this.$emit("search-hide", event);
            }

            if(key === 13){
                const searchKeyword = this.keyword;
                this.keyword = ''
                this.$store.dispatch('setSearchKeyword', searchKeyword)
                if(this.$route.name != 'Search'){
                    //this.goSearch(searchKeyword)
                    this.goSearch()
                }
            }
        }
    }
};
</script>